/* jp-search.js — full-screen search overlay behaviour (Kinzoku §27 + v2-4).
   Opens via jp-layers (listens for jp:layer:open id="search"). Normalises the
   query through a professional-terminology SYN map, fetches Kinzoku predictive
   results from the jp-predictive-search section (correct prices via Liquid),
   and renders empty / skeleton / results / no-results. Recents in localStorage.
   No jQuery / no frameworks. Guarded against double execution. */
(() => {
  if (window.__jpSearchInit) return;
  window.__jpSearchInit = true;

  /* professional-terminology synonyms (query is normalised before the fetch) */
  const SYN = {
    'vg-10': 'vg10', 'v-10': 'vg10', 'v10': 'vg10',
    'ats': 'ats314', 'ats-314': 'ats314',
    '440': '440c',
    'shears': 'scissors', 'shear': 'scissors', 'scissor': 'scissors',
    'texturizing': 'texture', 'texturising': 'texture', 'texturizer': 'texture',
    'thinners': 'thinning', 'thinner': 'thinning',
    'sharpen': 'sharpening', 'sharpened': 'sharpening',
    'left-handed': 'lefty', 'lefthanded': 'lefty', 'leftie': 'lefty', 'handed': '',
    'inch': '', 'in': '', '5': '5.0', '6': '6.0', '7': '7.0'
  };
  const RECENT_KEY = 'jp_recent_searches';

  const norm = (q) =>
    q.toLowerCase().replace(/[″"']/g, ' ').replace(/[^a-z0-9.\s-]/g, ' ')
      .split(/[\s/]+/).filter(Boolean)
      .map((t) => (SYN[t] !== undefined ? SYN[t] : t)).filter(Boolean).join(' ');

  const getRecent = () => { try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch { return []; } };
  const setRecent = (arr) => { try { localStorage.setItem(RECENT_KEY, JSON.stringify(arr.slice(0, 5))); } catch {} };
  const recordRecent = (q) => {
    q = (q || '').trim(); if (!q) return;
    const r = getRecent().filter((x) => x.toLowerCase() !== q.toLowerCase());
    r.unshift(q); setRecent(r);
  };
  const esc = (s) => String(s).replace(/[<>&"]/g, (c) => ({ '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;' }[c]));

  let overlay, input, clearBtn, emptyEl, liveEl, recentEl, cfg = {}, ctrl, timer;

  const init = (root) => {
    if (root.__jpSoBound) return;
    root.__jpSoBound = true;
    overlay = root;
    input = root.querySelector('[data-jp-so-input]');
    clearBtn = root.querySelector('[data-jp-so-clear]');
    emptyEl = root.querySelector('[data-jp-so-empty]');
    liveEl = root.querySelector('[data-jp-so-live]');
    recentEl = root.querySelector('[data-jp-so-recent]');
    try { cfg = JSON.parse(root.querySelector('[data-jp-so-config]').textContent); } catch { cfg = {}; }
    cfg.strings = cfg.strings || {};
    if (!input) return;

    input.addEventListener('input', onInput);
    input.addEventListener('keydown', onKeydown);

    root.addEventListener('click', (e) => {
      const setq = e.target.closest('[data-jp-soq]');
      if (setq) { input.value = setq.getAttribute('data-jp-soq'); clearBtn.hidden = false; runSearch(); input.focus(); return; }
      if (e.target.closest('[data-jp-so-clear]')) { input.value = ''; clearBtn.hidden = true; showEmpty(); input.focus(); return; }
      if (e.target.closest('[data-jp-so-clear-recent]')) { setRecent([]); renderRecent(); return; }
      if (e.target.closest('[data-jp-so-item]')) recordRecent(input.value);
    });
  };

  const renderRecent = () => {
    const r = getRecent();
    if (!r.length) { recentEl.hidden = true; recentEl.innerHTML = ''; return; }
    recentEl.hidden = false;
    recentEl.innerHTML =
      '<div class="jp-so__h">' + esc(cfg.strings.recent || 'Recent') +
      '<button type="button" class="jp-so__clear-recent" data-jp-so-clear-recent>' + esc(cfg.strings.clearAll || 'Clear all') + '</button></div>' +
      '<div class="jp-so__pills">' +
      r.map((q) => '<button type="button" class="jp-so__pill" data-jp-soq="' + esc(q) + '">' + esc(q) + '</button>').join('') +
      '</div>';
  };

  const showEmpty = () => {
    if (ctrl) ctrl.abort();
    liveEl.hidden = true; liveEl.innerHTML = '';
    emptyEl.hidden = false; renderRecent();
    input.setAttribute('aria-expanded', 'false');
  };
  const showLive = () => { emptyEl.hidden = true; liveEl.hidden = false; input.setAttribute('aria-expanded', 'true'); };

  const skeleton = () => {
    showLive();
    let s = '<div class="jp-so__grid"><div class="jp-so__col">';
    for (let i = 0; i < 4; i++) s += '<div class="jp-so__skel"><span class="a"></span><span></span></div>';
    s += '</div></div>';
    liveEl.innerHTML = s;
  };

  const noResults = (q) => {
    showLive();
    liveEl.innerHTML =
      '<div class="jp-so__none"><span class="jp-so__none-k" aria-hidden="true">無</span>' +
      '<b>' + esc(cfg.strings.none || 'No match.') + '</b>' +
      '<p>' + esc(cfg.strings.noneSub || '') + '</p>' +
      '<div class="row">' +
      '<a class="jp-btn jp-btn--ghost-dark jp-btn--sm" href="' + esc(cfg.allUrl || '/collections/all') + '">' + esc(cfg.strings.noneBrowse || 'Browse all') + '</a>' +
      '<a class="jp-btn jp-btn--primary jp-btn--sm" href="' + esc(cfg.searchUrl || '/search') + '?q=' + encodeURIComponent(q) + '">' + esc(cfg.strings.viewAll || 'See all results') + '</a>' +
      '</div></div>';
  };

  const onInput = () => {
    clearBtn.hidden = !input.value;
    input.removeAttribute('aria-activedescendant'); /* drop stale active option before results re-render */
    window.clearTimeout(timer);
    if (!input.value.trim()) { showEmpty(); return; }
    timer = window.setTimeout(runSearch, 200);
  };

  const runSearch = () => {
    const raw = input.value.trim();
    if (!raw) { showEmpty(); return; }
    const q = norm(raw) || raw;
    skeleton();
    if (ctrl) ctrl.abort();
    ctrl = new AbortController();
    const url = (cfg.predictiveUrl || '/search/suggest') + '?q=' + encodeURIComponent(q) +
      '&section_id=jp-predictive-search' +
      '&resources[type]=product,collection,article,page&resources[limit]=6&resources[options][unavailable_products]=last';
    fetch(url, { signal: ctrl.signal })
      .then((r) => r.text())
      .then((html) => {
        const rendered = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-jp-so-rendered]');
        if (rendered && rendered.querySelector('[data-jp-so-item]')) liveEl.innerHTML = rendered.innerHTML;
        else noResults(raw);
      })
      .catch((e) => { if (e.name !== 'AbortError') noResults(raw); });
  };

  const onKeydown = (e) => {
    /* type="search" inputs swallow the Escape keydown (native clear) before it
       reaches the document-level layer handler — close the overlay explicitly. */
    if (e.key === 'Escape') {
      e.preventDefault();
      if (window.JapanScissors && window.JapanScissors.layers) window.JapanScissors.layers.close('search');
      return;
    }
    const items = liveEl.hidden ? [] : Array.prototype.slice.call(liveEl.querySelectorAll('[data-jp-so-item]'));
    if (e.key === 'Enter') {
      const active = liveEl.querySelector('[data-jp-so-item].is-active') || items[0];
      if (active) { e.preventDefault(); recordRecent(input.value); window.location.href = active.getAttribute('href'); }
      else if (input.value.trim()) { e.preventDefault(); recordRecent(input.value); window.location.href = (cfg.searchUrl || '/search') + '?q=' + encodeURIComponent(input.value.trim()); }
      return;
    }
    if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && items.length) {
      e.preventDefault();
      input.setAttribute('aria-expanded', 'true');
      let i = items.findIndex((n) => n.classList.contains('is-active'));
      items.forEach((n) => { n.classList.remove('is-active'); n.setAttribute('aria-selected', 'false'); });
      i = e.key === 'ArrowDown' ? (i + 1) % items.length : (i - 1 + items.length) % items.length;
      const cur = items[i];
      cur.classList.add('is-active');
      cur.setAttribute('aria-selected', 'true');
      if (cur.id) input.setAttribute('aria-activedescendant', cur.id); /* announce the active option to AT */
      cur.scrollIntoView({ block: 'nearest' });
    }
  };

  /* opened by jp-layers — it focuses [data-jp-so-input] via data-jp-autofocus,
     so we only reset state here (no second focus call → no focus flash) */
  document.addEventListener('jp:layer:open', (e) => {
    if (e.detail.id !== 'search' || !overlay || !input) return;
    input.value = ''; clearBtn.hidden = true; showEmpty();
    input.removeAttribute('aria-activedescendant'); input.setAttribute('aria-expanded', 'false');
  });

  const boot = () => { const el = document.querySelector('[data-jp-layer="search"]'); if (el) init(el); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
